import BetterPath from "./BetterPath";

export default BetterPath;
